<template>
  <div>
    <div class="multi-select">
      <p class="additional-role-question">{{question}}</p>
      <p class="additional-role-helper" v-html="helperTextAdditionalRole"></p>
      <div :class="[{mandatory: isMandatory}]">
        <div v-for="option in options" :key="option.value">
          <b-checkbox v-model="roles" @input="additionalQuestionChanged" @change.native="cleanUpOptions" :native-value="option.text"
                       :input-id="option.text.replace(' ', '_').toLowerCase()">
          {{option.text}}
          </b-checkbox>
          <div v-if="option.disclaimer && roles.includes(qualifiedPerson)"><p class="qp-role-helper">{{option.disclaimer}}</p></div>
        </div>
      </div>
    </div>
    </div>
</template>
<script>
/* eslint-disable vue/no-mutating-props */

export default {
  name: 'AdditionalRole',
  created() {
    this.roles = this.existingValue;
  },
  props: {
    isMandatory: Boolean,
    options: {
      type: Array,
      default() { return [{ value: 0, text: 'Loading' }]; },
    },
    question: String,
    helperTextAdditionalRole: String,
    existingValue: Array,
  },
  methods: {
    additionalQuestionChanged() {
      this.saveAdditionalRole(this.roles);
    },
    saveAdditionalRole(selected) {
      this.$emit('question-answered', selected);
    },
    cleanUpOptions(e) {
      if (!e.srcElement.checked) {
        return;
      }

      this.roles = e.srcElement.value === this.notApplicable
        ? [this.notApplicable]
        : this.roles.filter((r) => r !== this.notApplicable);
      this.saveAdditionalRole(this.roles);
    },
  },
  data() {
    return {
      roles: [],
      notApplicable: 'Not Applicable',
      qualifiedPerson: 'Qualified Person',
    };
  },
};
</script>
